import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';
import Logo from 'assets/expressable-logo.svg?react';
import { Link } from 'components/Link';
import { useUserClientsWithActiveClient } from 'domains/auth/UserClientsWrapper/useUserClients';
import { getClientRedirect } from 'domains/client';
import { getNavBarRoutesForUser } from 'router/routes';
import { useNavigation } from 'utils/hooks/useNavigation';
import { HamburgerMenu } from 'components/Layout/AuthedLayout/AuthedHeader/NavigationBar/HamburgerMenu';
import { LanguageSwitcher } from 'components/LanguageSwitcher';
import { AccountMenu } from './AccountMenu';
import { DesktopNavigationBar } from './NavigationBar/DesktopNavBar';

export const AuthedHeader = () => {
  const { activeClient } = useUserClientsWithActiveClient();
  const { routes } = useNavigation();
  const flags = useFlags();

  const navigationRoutes = useMemo(
    () => getNavBarRoutesForUser(activeClient.onboardingStatus, flags),
    [activeClient, flags],
  );

  return (
    <header className="flex items-center justify-between relative bg-cream-50 py-20 px-24 min-h-[88px] border-b border-black-12%">
      <div className="flex items-center justify-start">
        <HamburgerMenu navigationItems={navigationRoutes} className="mr-8" />
        <Link to={getClientRedirect(activeClient, routes.root)} className="text-primary-500 fill-current h-24">
          <Logo className="fill-current text-black-100% h-full w-auto" title="Expressable" />
        </Link>
        <LanguageSwitcher className="2xl-d:hidden ml-16" />
      </div>

      <DesktopNavigationBar navigationItems={navigationRoutes} />

      <AccountMenu />
    </header>
  );
};
